import SearchInput from 'components/SearchInput';
import ListTabs from 'components/ListTabs';
import ListWrapper from 'components/ListWrapper';
import Typography from 'components/Typography';
import ListActionsWrapper from 'components/ListActionsWrapper';
import DataTable from 'components/DataTable';
import styles from './Transactions.module.scss';
import calendar from '../DeliveryPlanner/icons/calendar.svg';
import {DataTableSchemaItem} from 'types';
import useTransactions from './useTransactions';
import Pagination from 'components/Pagination';
import DateTimePicker from 'components/DateTimePicker';
import Select from 'components/Select';
import {components} from 'react-select';
import Button from 'components/Button';
import Modal from 'components/Modal';
import TextField from 'components/TextField';
import {cc_format} from 'pages/UserForm/CardInformation/CardInformation';
import {useFieldArray} from 'react-hook-form';
import FormGroup from 'components/FormGroup';
import {validateEmail} from 'utils/validators';
// import {PieChart} from 'react-minimal-pie-chart';
// import classNames from 'classnames';
import {phoneFormat} from 'helpers/phoneFormat';

// import chartImg from './chart.svg';

const MM_SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'transaction_id',
    header: 'ID',
    sortable: true,
    index: 0,
  },
  {dataKey: 'amount', header: 'Amount', sortable: true, index: 1},
  {
    dataKey: 'transaction_date',
    header: 'Date',
    sortable: true,
    align: 'center',
    index: 2,
  },
  {
    dataKey: 'transaction_origin',
    header: 'Source',
    align: 'center',
    sortable: false,
    index: 3,
  },
  {dataKey: 'list_rx', header: 'List of RXs', sortable: false, index: 5},
  {dataKey: 'list_orders', header: 'List of Orders', sortable: false, index: 6},
  {dataKey: 'customer_full_name', header: 'Patient', sortable: true, index: 7},
  {dataKey: 'card_type', header: 'Card Type', sortable: true, index: 4},
];

function Transactions() {
  const {
    data,
    totalPages,
    dailyCount,
    loading,
    sortBy,
    sortOrder,
    tabs,
    status,
    onSort,
    setStatus,
    keyWord,
    setKeyWord,
    onChangeData,
    date,
    setCreditType,
    creditType,
    totalAmount,
    startDate,
    endDate,
    // chartVisible,
    // setChartVisible,
    // chart,
    pageSize,
    setPageSize,
    count,
    control,
    register,
    handleSubmit,
    setValue,
    reset,
    errors,
    currentPage,
    setCurrentPage,
    handleNavigateRequest,
    handleDateChange,
    onSubmit,
    visible,
    setVisible,
    submitting,
    birthdate,
    history,
    rolePermission,
  } = useTransactions();

  const {fields, append, remove} = useFieldArray({
    control,
    name: 'list_rx',
  });
  return (
    <>
      <div className={styles.top_header}>
        <Typography textAlign="right" variant="h2">
          Transactions
        </Typography>
        <div className={styles.count_wrapper}>
          {!!rolePermission['transactions']?.permissions?.write && (
            <Button onClick={() => setVisible(true)} color="blue">
              Add transaction
            </Button>
          )}
          <Typography textAlign="right" variant="h4">
            Count: {dailyCount} {'  |  '} Total: $
            {Number(totalAmount).toLocaleString('en-US') || 0}
          </Typography>
        </div>
      </div>
      <ListWrapper>
        <div style={{position: 'relative'}} className={styles.row}>
          <ListTabs
            className={styles.tabs}
            onChange={setStatus}
            isSupportPage={false}
            activeTabValue={status}
            tabs={tabs}
          />
          {/* <Button
            size="sm"
            className={styles.reportBtn}
            onClick={() => setChartVisible(true)}
            color="blue"
          >
            Report
          </Button>
          <div onClick={() => setChartVisible(true)} className={styles.chart}>
            <img src={chartImg} alt="chart" />
          </div> */}
        </div>
        <ListActionsWrapper>
          <div className={styles.row}>
            <SearchInput
              className={styles.input}
              value={keyWord}
              onChange={(val) => {
                setKeyWord(val.target.value);
                setCurrentPage(1);
                history.push('/transactions/page/1');
                sessionStorage.setItem(
                  `searchKey_transaction`,
                  val.target.value
                );
              }}
              placeholder="Search"
            />
          </div>
          <div className={styles.preferenceDate}>
            <DateTimePicker
              icon={calendar}
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              showTimeSelect={false}
              dateFormat="MM/dd/yy E"
              value={date}
              placeholder="Transaction Date"
              customInput={styles.customInput}
              onChange={(data) => {
                setCurrentPage(1);
                history.push('/transactions/page/1');
                onChangeData(data);
              }}
            />
            <Select
              className={styles.selectCon}
              isSearchable={false}
              onChange={(val: any) => {
                setCreditType(val);
                setCurrentPage(1);
                history.push('/transactions/page/1');
                sessionStorage.setItem('creditType', JSON.stringify(val));
              }}
              options={[
                {label: 'Sale', value: 'CreditSale'},
                {label: 'Refund', value: 'CreditReturn'},
                {label: 'Account Verify', value: 'CreditAccountVerify'},
              ]}
              value={creditType}
              placeholder={
                <span className="select-placeholder-text">Credit Type</span>
              }
              isClearable
              components={{
                Input: () => null,
                DropdownIndicator: (props) =>
                  !creditType ? (
                    <components.DropdownIndicator {...props} />
                  ) : null,
                Control: ({children, ...props}) => (
                  <components.Control {...props} className="select-row">
                    {children}
                  </components.Control>
                ),

                IndicatorSeparator: () => null,
              }}
            />
          </div>
        </ListActionsWrapper>
        <DataTable
          schema={MM_SCHEMA}
          data={data}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onClick={handleNavigateRequest}
          onSort={onSort}
          loading={loading}
        />
        {!loading && (
          <Pagination
            count={count}
            basePath={'/transactions'}
            page={currentPage}
            total={totalPages}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setCurrentPage={setCurrentPage}
          />
        )}
      </ListWrapper>
      {/* <Modal
        isOpen={chartVisible}
        className={classNames(styles.list_wrapper)}
        onRequestClose={() => setChartVisible(false)}
        onClose={() => setChartVisible(false)}
      >
        <Typography variant="h1">Report</Typography>
        <div className={styles.chart_wrapper}>
          <PieChart className={styles.pieChart} data={chart} />
          <div>
            {chart.map((item, index) => (
              <div key={index} className={styles.chartItem}>
                <div
                  style={{
                    backgroundColor: item.color,
                    width: 15,
                    height: 15,
                    borderRadius: 10,
                  }}
                />
                <p>
                  {item.title}: {item.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Modal> */}
      <Modal
        isOpen={visible}
        onAfterClose={() => reset()}
        onClose={() => setVisible(false)}
        className={styles.list_wrapper}
        onRequestClose={() => setVisible(false)}
      >
        <Typography variant="h2">Add new transaction</Typography>
        <div className={styles.formWrapper}>
          <Typography style={{marginTop: 20}} variant="h4">
            Customer information
          </Typography>
          <FormGroup columns={2}>
            <TextField
              label="First name"
              placeholder="First name"
              {...register('first_name', {required: 'Required'})}
              error={errors.first_name?.message}
            />
            <TextField
              label="Last name"
              placeholder="Last name"
              {...register('last_name', {required: 'Required'})}
              error={errors.last_name?.message}
            />
          </FormGroup>

          <FormGroup columns={1}>
            <TextField
              label="Email address"
              placeholder="Email address"
              {...register('email', {
                required: 'Required',
                validate: validateEmail,
              })}
              error={errors.email?.message}
            />
          </FormGroup>

          <FormGroup columns={1}>
            <TextField
              label="Phone number"
              placeholder="(123) 456-7890"
              {...register('phone', {
                required: 'Required',
                minLength: {
                  value: 14,
                  message: 'Phone number length must be 14',
                },
              })}
              onChange={(e) => {
                e.target.value = phoneFormat(e.target.value);
              }}
              maxLength={14}
              error={errors.phone?.message}
            />
          </FormGroup>

          <FormGroup columns={1}>
            <TextField
              label="Date of birth"
              placeholder="mm/dd/yyyy"
              {...register('birthday', {
                required: 'Required',
              })}
              value={birthdate}
              onChange={handleDateChange}
              maxLength={10}
              error={errors.birthday?.message}
            />
          </FormGroup>
          <FormGroup columns={1}>
            <TextField
              label="Patient number"
              placeholder="Patient number"
              {...register('patient_no', {
                required: 'Required',
              })}
              error={errors.patient_no?.message}
            />
          </FormGroup>
        </div>
        <Typography style={{marginTop: 20}} variant="h4">
          List RX
        </Typography>
        {fields.map((item, index) => {
          return (
            <div key={index}>
              <Typography style={{marginTop: 30, color: '#000'}} variant="h5">
                RX - {index + 1}
              </Typography>
              <TextField
                placeholder="Id"
                label="Id"
                {...register(`list_rx.${index}.id`, {
                  required: 'Required',
                })}
                error={
                  errors?.list_rx ? errors.list_rx[index]?.id?.message : ''
                }
              />
              <TextField
                placeholder="Rx number"
                label="Rx number"
                {...register(`list_rx.${index}.rx_no`, {
                  required: 'Required',
                })}
                error={
                  errors.list_rx ? errors.list_rx[index]?.rx_no?.message : ''
                }
              />
              <TextField
                placeholder="Refill number"
                label="Refill number"
                {...register(`list_rx.${index}.refill_no`, {
                  required: 'Required',
                })}
                error={
                  errors.list_rx
                    ? errors.list_rx[index]?.refill_no?.message
                    : ''
                }
              />
              <TextField
                placeholder="Drug name"
                label="Drug name"
                {...register(`list_rx.${index}.drug_name`, {
                  required: 'Required',
                })}
                error={
                  errors.list_rx
                    ? errors.list_rx[index]?.drug_name?.message
                    : ''
                }
              />
              <TextField
                placeholder="Amount due"
                label="Amount due"
                {...register(`list_rx.${index}.amount_due`, {
                  required: 'Required',
                })}
                type="number"
                error={
                  errors.list_rx
                    ? errors.list_rx[index]?.amount_due?.message
                    : ''
                }
              />
              {index > 0 && (
                <Button
                  onClick={() => remove(index)}
                  style={{marginLeft: 'auto', marginTop: 15}}
                  color="danger"
                >
                  Delete
                </Button>
              )}
            </div>
          );
        })}
        <p
          onClick={() => {
            append({
              id: '',
              rx_no: '',
              refill_no: '',
              drug_name: '',
              amount_due: '',
            });
          }}
          style={{
            fontWeight: 'bold',
            cursor: 'pointer',
            color: '#000',
            textAlign: 'right',
            marginLeft: 'auto',
          }}
        >
          +Add RX
        </p>
        <TextField
          placeholder="Amount"
          label="Amount"
          type="number"
          error={errors.amount?.message}
          {...register('amount', {
            required: 'Required',
          })}
        />
        <TextField
          placeholder="Card number"
          label="Masked card number"
          {...register('card', {
            required: 'Required',
          })}
          error={errors.card?.message}
          onChange={(e) => setValue('card', cc_format(e.target.value))}
        />

        <Button
          loading={submitting}
          className={styles.addBtn}
          onClick={handleSubmit(onSubmit)}
          color="blue"
        >
          Add Transaction
        </Button>
      </Modal>
    </>
  );
}

export default Transactions;
